import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { downloadFile } from '../../common/download';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';

const initialState = {
  buttons : false,
}
export const uploadBulkDataTemplate = AsyncThunkAction('/uploadBulkDataTemplate', API_BASE_URL + ApiURLs.BulkUserUpload.upload)

export const getBulkUploadTemplate = createAsyncThunk('/downloadBulkUploadTemplate', async (payload, { signal, getState }) => {

  const token = getState().auth.token
  const url = API_BASE_URL + ApiURLs.BulkUserUpload.download
  const onSuccessCallBack = () => {
    AppToast.Toast.success({ title: getConfiguredLabel(DocumentsPage, success), message: getConfiguredLabel(DocumentsPage, downloadSuccessfulMessage) })
  }
  const onErrorCallBack = () => {
    AppToast.Toast.error({ title: "Download Failed", message: "Unexpected error occurred." })
  }
  return await downloadFile(url, payload, token, onSuccessCallBack, onErrorCallBack)
});
const bulkUploadSlice = createSlice({
  name: 'bulkUpload',
  initialState: initialState,
  reducers: {
    setBulkButtonPopUp : (state, action) => {
      state.buttons = action.payload
  },
 }
 
})
export default bulkUploadSlice.reducer
export const { setBulkButtonPopUp } = bulkUploadSlice.actions;
